<template>
  <div>
    <b-container class="bv-example-row">
      <b-row>
        <b-col cols="12">
          <b-tabs defaultActiveKey="1" class="air-tabs-bordered mb-2" justified>
            <!-- <a-tab-pane v-for="aTag in tags" :tab="aTag.title" :key="aTag.key"> -->
            <b-tab title="<N>ames" active="">
              <b-table
                :items="serveNameList"
                :fields="tableNameConfig.fields"
                responsive="sm"
              >
              </b-table>
              <b-button
                @click="isModalAddNewName = true"
                variant="outline-secondary"
                class="fa fa-plus button-add"
              >
              </b-button>
            </b-tab>
            <b-tab title="<Nu>mbers">
              <b-table
                :items="serveNumberList"
                :fields="tableNumberConfig.fields"
                responsive="sm"
              >
              </b-table>
            </b-tab>
            <b-tab title="<P>laces">
              <b-table
                :items="servePlaceList"
                :fields="tablePlaceConfig.fields"
                responsive="sm"
              >
              </b-table>
            </b-tab>
            <!-- :sort-by.sync="tableNameConfig.sortBy"
                :sort-desc.sync="tableNameConfig.sortDesc" -->
            <b-tab title="<T>ools">
              <b-table
                :items="serveToolList"
                :fields="tableToolConfig.fields"
                responsive="sm"
              >
              </b-table>
            </b-tab>
            <!-- </a-tab-pane> -->
          </b-tabs>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
// import SwitchFilter from "@/components/_savco/switch";
// import SavcoUserMenu from "@/components/_savco/layout/TopBar/UserMenu";
export default {
  components: {
    // SwitchFilter,
    // SavcoUserMenu
  },
  beforeCreate() {},
  methods: {
    handleFilterFocus(e) {
      console.log(e, "where to handle filter focus");
    },
    handleAddFocusBtnClick: function() {
      console.log("triggered add button");
    }
  },
  computed: {
    serveNameList() {
      let tableData = this.$store.getters["user/listNames"];
      let beforeFilterDeletedAt = tableData.map(el => {
        return {
          firstname: el.info ? el.info.firstname : null,
          lastname: el.info ? el.info.lastname : null,
          uid: el.uid,
          numbers: el.info.number,
          place: el.place
            ? `${el.place.address1} ${el.place.address2} ${el.place.city},${el.place.state} ${el.place.zip}`
            : ""
        };
      });
      return beforeFilterDeletedAt
        .filter(el => !el._deleted_at)
        .filter(el => el.firstname);
    },
    serveNumberList() {
      let tableData = this.$store.getters["user/listNames"];
      let beforeFilterDeletedAt = tableData.map(el => {
        return {
          numbername: el.info ? el.info.numbername : null,
          uid: el.uid,
          numbers: el.info.number,
          place: el.place
            ? `${el.place.address1} ${el.place.address2} ${el.place.city},${el.place.state} ${el.place.zip}`
            : ""
        };
      });
      return beforeFilterDeletedAt
        .filter(el => !el._deleted_at)
        .filter(el => el.numbername);
    },
    servePlaceList() {
      let tableData = this.$store.getters["user/listNames"];
      let beforeFilterDeletedAt = tableData.map(el => {
        return {
          placename: el.info ? el.info.placename : null,
          uid: el.uid,
          numbers: el.info.number,
          place: el.place
            ? `${el.place.address1} ${el.place.address2} ${el.place.city},${el.place.state} ${el.place.zip}`
            : ""
        };
      });
      return beforeFilterDeletedAt
        .filter(el => !el._deleted_at)
        .filter(el => el.placename);
    },
    serveToolList() {
      // debugger;
      let tableData = this.$store.getters["user/listTools"];
      let beforeFilterDeletedAt = tableData.map(el => {
        return {
          ...el,
          custom: el.text,
          tool: el.tooldetail ? el.tooldetail.name : "",
          description: el.tooldetail ? el.tooldetail.description : "",
          created: el._created_at
        };
      });
      return beforeFilterDeletedAt.filter(el => !el._deleted_at);
    }
  },
  data() {
    return {
      tags: [
        {
          title: "<> Names",
          key: 0
        },
        {
          title: "<> Numbers",
          key: 1
        },
        {
          title: "<> Places",
          key: 2
        },
        {
          title: "<> Tools",
          key: 3
        }
      ],
      // FIELD FOR ADD NAMES
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      notes: "",
      //////////////////////
      tableNameConfig: {
        fields: [
          { key: "Icon", sortable: false, label: "", thStyle: "width: 10%" },
          {
            key: "firstname",
            sortable: true,
            label: "First Name",
            thStyle: "width: 10%"
          },
          {
            key: "lastname",
            sortable: true,
            label: "Last Name",
            thStyle: "width: 10%"
          },
          {
            key: "place",
            sortable: true,
            label: "Address",
            thStyle: "width: 10%"
          },
          { key: "Actions", label: "", sortable: false, thStyle: "width: 60%" }
        ]
      },
      tableNumberConfig: {
        fields: [
          { key: "Icon", sortable: false, label: "", thStyle: "width: 10%" },
          {
            key: "numbername",
            sortable: true,
            label: "Number",
            thStyle: "width: 80%"
          },
          { key: "Actions", label: "", sortable: false, thStyle: "width: 10%" }
        ]
      },
      tablePlaceConfig: {
        fields: [
          { key: "Icon", sortable: false, label: "", thStyle: "width: 10%" },
          {
            key: "placename",
            sortable: true,
            label: "Name",
            thStyle: "width: 40%"
          },
          {
            key: "place",
            sortable: true,
            label: "Address",
            thStyle: "width: 40%"
          },
          { key: "Actions", label: "", sortable: false, thStyle: "width: 10%" }
        ]
      },
      tableToolConfig: {
        fields: [
          { key: "Icon", sortable: false, label: "", thStyle: "width: 10%" },
          {
            key: "custom",
            sortable: true,
            label: "Name",
            thStyle: "width: 10%"
          },
          { key: "tool", sortable: true, label: "Tool", thStyle: "width: 10%" },
          {
            key: "description",
            sortable: false,
            label: "Description",
            thStyle: "width: 30%"
          },
          {
            key: "created",
            sortable: false,
            label: "Added",
            thStyle: "width: 30%"
          },
          { key: "actions", label: "", sortable: false, thStyle: "width: 10%" }
        ]
      },
      spheres: [
        { sphere: "s" },
        { sphere: "h" },
        { sphere: "e" },
        { sphere: "f" }
      ],
      isModalAddNewName: false
    };
  },
  mounted() {
    this.$store.dispatch("user/getListNames");
    this.$store.dispatch("user/getListTools");
  }
};
</script>
<style lang="scss" module>
@import "./style.module.scss";
</style>
<style scoped>
.button-add {
  width: 100%;
  background-color: #575757;
  color: white;
}
</style>
